var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01PanVerfication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 372.6",
    style: {
      enableBackground: "new 0 0 500 372.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6E6E6;}\n\t.st1{fill:#E0E0E0;}\n\t.st2{fill:#FAFAFA;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#F5F5F5;}\n\t.st5{fill:#F0F0F0;}\n\t.st6{fill:#EBEBEB;}\n\t.st7{fill:#042b62;}\n\t.st8{opacity:0.1;enable-background:new    ;}\n\t.st9{opacity:0.2;enable-background:new    ;}\n\t.st10{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st11{fill:#E4897B;}\n\t.st12{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\n\t.st13{opacity:0.31;fill:#042b62;enable-background:new    ;}\n\t.st14{fill:#CE6F64;}\n\t.st15{opacity:0.7;enable-background:new    ;}\n\t.st16{fill:#263238;}\n\t.st17{fill:#DE5753;}\n\t.st18{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.3,
    y: 338,
    className: "st0",
    width: 34.4,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.7,
    y: 338.2,
    className: "st0",
    width: 19.4,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.8,
    y: 337.6,
    className: "st0",
    width: 39.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.2,
    y: 334,
    className: "st0",
    width: 17.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.6,
    y: 334.1,
    className: "st0",
    width: 53,
    height: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237,282.8H43.9c-3.1,0-5.7-2.6-5.7-5.7V5.7c0-3.1,2.6-5.7,5.7-5.7H237c3.2,0,5.7,2.6,5.7,5.7l0,0v271.4 C242.7,280.3,240.2,282.8,237,282.8z M43.9,0.2c-3,0-5.5,2.4-5.5,5.5v271.4c0,3,2.4,5.5,5.5,5.5H237c3,0,5.5-2.4,5.5-5.5V5.7 c0-3-2.4-5.5-5.5-5.5C237,0.2,43.9,0.2,43.9,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.3,282.8H260.2c-3.2,0-5.7-2.6-5.7-5.7V5.7c0-3.1,2.6-5.7,5.7-5.7h193.1c3.1,0,5.7,2.5,5.7,5.7v271.4 C459,280.3,456.5,282.8,453.3,282.8z M260.2,0.2c-3,0-5.5,2.4-5.5,5.5v271.4c0,3,2.4,5.5,5.5,5.5h193.1c3,0,5.5-2.4,5.5-5.5V5.7 c0-3-2.4-5.5-5.5-5.5C453.3,0.2,260.2,0.2,260.2,0.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.9,
    y: 88.6,
    className: "st1",
    width: 60,
    height: 65.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.1,
    y: 88.6,
    className: "st2",
    width: 65.2,
    height: 65.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.8,
    y: 95.4,
    className: "st3",
    width: 51.8,
    height: 52.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M163,121.5L163,121.5c0-6.8,5.5-12.3,12.4-12.3h2.8c6.8,0,12.3,5.5,12.3,12.3l0,0c0,6.8-5.5,12.3-12.3,12.3 h-2.8C168.5,133.8,163,128.3,163,121.5L163,121.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.2,104.3c-17.4,0-31.5-14.1-31.5-31.5s14.1-31.5,31.5-31.5h5.7v63H92.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 97.9,
    cy: 72.8,
    r: 31.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 97.9,
    cy: 72.8,
    r: 23.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "107.7,81.7 96.1,73.6 99.8,55.6 103.1,56.3 99.8,72.1 109.6,78.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.4,
    y: 215.1,
    className: "st1",
    width: 42.9,
    height: 115.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "340.9,331 352.3,331 352.3,311.8 328.9,311.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.2,
    y: 215.1,
    className: "st1",
    width: 42.9,
    height: 115.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 215.1,
    className: "st2",
    width: 267.3,
    height: 109.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "96.6,331 85.1,331 85.1,311.8 108.6,311.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 224.4,
    className: "st5",
    width: 249.5,
    height: 40.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 274.4,
    className: "st5",
    width: 249.5,
    height: 40.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 224.4,
    className: "st1",
    width: 212.9,
    height: 40.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.5,229.9h-12.9c0,0,2.2,7.8,2.2,12.3s-9.9,22.5,4.2,22.5s4.2-17.9,4.2-22.5S159.5,229.9,159.5,229.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.6,243.4v7.1c0,7.8,7.6,14.2,16.8,14.2h8.4c9.3,0,16.8-6.4,16.8-14.2v-7.1L108.6,243.4L108.6,243.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 274.4,
    className: "st1",
    width: 212.9,
    height: 40.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.6,
    y: 280.7,
    className: "st3",
    width: 19.9,
    height: 33.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 281.2,
    className: "st0",
    width: 1.4,
    height: 33.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M235.3,314.7h-3.5c-0.3,0-0.5-0.2-0.5-0.5v-32.8c0-0.3,0.2-0.5,0.5-0.5h3.5c0.3,0,0.5,0.2,0.5,0.5v32.8 C235.8,314.5,235.6,314.7,235.3,314.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.4,
    y: 288.7,
    className: "st3",
    width: 4.4,
    height: 7.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.4,
    y: 299,
    className: "st3",
    width: 4.4,
    height: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M230.5,314.7h-18c-0.3,0-0.5-0.2-0.5-0.5v-32.8c0-0.3,0.2-0.5,0.5-0.5h18c0.3,0,0.5,0.2,0.5,0.5v32.8 C231,314.5,230.8,314.7,230.5,314.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.8,
    y: 277.2,
    className: "st3",
    width: 22,
    height: 36.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.4,
    y: 277.8,
    className: "st0",
    width: 1.5,
    height: 36.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.8,314.7H224c-0.3,0-0.5-0.2-0.5-0.5V278c0-0.3,0.2-0.5,0.5-0.5h3.8c0.3,0,0.5,0.2,0.5,0.5v36.1 C228.4,314.5,228.1,314.7,227.8,314.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.5,
    y: 289.4,
    className: "st3",
    width: 4.9,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.5,
    y: 293,
    className: "st3",
    width: 4.9,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.5,
    y: 296.7,
    className: "st3",
    width: 4.9,
    height: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M222.5,314.7h-19.8c-0.3,0-0.5-0.2-0.5-0.5V278c0-0.3,0.2-0.5,0.5-0.5h19.8c0.3,0,0.5,0.2,0.5,0.5v36.1 C223.1,314.5,222.8,314.7,222.5,314.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M176.7,301.9c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6l0,0 C174.2,296.3,176.7,298.8,176.7,301.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.1,304.6c0,2.4-2,4.4-4.4,4.4s-4.4-2-4.4-4.4s2-4.4,4.4-4.4S167.1,302.2,167.1,304.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M186.4,304.6c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6C183.8,299,186.4,301.5,186.4,304.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M195.6,303c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6S195.6,299.9,195.6,303L195.6,303z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M147.2,303.7c0,0,0.8,11,30.4,11s30.4-11,30.4-11H147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M230.4,253.7c0,0,1.2,11,48.2,11s48.2-11,48.2-11L230.4,253.7L230.4,253.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 250,
    cy: 361.3,
    rx: 193.9,
    ry: 11.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--credit-card--inject-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.7,
    y: 334,
    className: "st7",
    width: 1,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.7,
    y: 334,
    className: "st8",
    width: 1,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.3,
    y: 244.6,
    className: "st7",
    width: 1,
    height: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.3,
    y: 268.2,
    className: "st7",
    width: 1,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.3,
    y: 244.6,
    className: "st8",
    width: 1,
    height: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.3,
    y: 268.2,
    className: "st8",
    width: 1,
    height: 8.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M394.3,192.5v151.4c0,8.3-6.8,15-15.1,15H120.8c-8.3,0-15-6.7-15-15V192.6c0-8.4,6.7-15.1,15-15.1h258.4 C387.5,177.5,394.2,184.2,394.3,192.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M394.3,192.5v151.4c0,8.3-6.8,15-15.1,15H120.8c-8.3,0-15-6.7-15-15V192.6c0-8.4,6.7-15.1,15-15.1h258.4 C387.5,177.5,394.2,184.2,394.3,192.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M363.2,237.9V287c0,3.6-2.9,6.5-6.5,6.5h-44.5c-3.6,0-6.5-2.9-6.5-6.5v-49.1c0-3.6,2.9-6.5,6.5-6.5h44.5 C360.2,231.4,363.1,234.3,363.2,237.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M363.2,237.9V287c0,3.6-2.9,6.5-6.5,6.5h-44.5c-3.6,0-6.5-2.9-6.5-6.5v-49.1c0-3.6,2.9-6.5,6.5-6.5h44.5 C360.2,231.4,363.1,234.3,363.2,237.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M366.2,310.2v6.3c0,3.7-3,6.7-6.7,6.7H154.8c-3.7,0-6.7-3-6.7-6.7v-6.3c0-3.7,3-6.7,6.7-6.7h204.7 C363.2,303.5,366.2,306.5,366.2,310.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M366.2,310.2v6.3c0,3.7-3,6.7-6.7,6.7H154.8c-3.7,0-6.7-3-6.7-6.7v-6.3c0-3.7,3-6.7,6.7-6.7h204.7 C363.2,303.5,366.2,306.5,366.2,310.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M170,257.3L170,257.3c0-1,0.8-1.8,1.8-1.8h122.3c1,0,1.8,0.8,1.8,1.8l0,0c0,1-0.8,1.8-1.8,1.8H171.8 C170.8,259.1,170,258.3,170,257.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M170,268.8L170,268.8c0-1,0.8-1.8,1.8-1.8h122.3c1,0,1.8,0.8,1.8,1.8l0,0c0,1-0.8,1.8-1.8,1.8H171.8 C170.8,270.6,170,269.8,170,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M170,280.8L170,280.8c0-1,0.8-1.8,1.8-1.8h122.3c1,0,1.8,0.8,1.8,1.8l0,0c0,1-0.8,1.8-1.8,1.8H171.8 C170.8,282.6,170,281.8,170,280.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M217.4,108c2.4,6.4,4.9,12.8,7.5,19.1s5.3,12.5,8.4,18.3c0.4,0.7,0.8,1.4,1.2,2.1l0.3,0.5l0.2,0.3 c0.2,0.2,0.4,0.5,0.6,0.8c0.9,1.2,2,2.4,3.1,3.6c2.3,2.5,4.7,4.9,7.1,7.3l14.7,14.5l-3.5,4.3c-5.8-3.9-11.5-8-17-12.4 c-2.7-2.2-5.4-4.4-8.1-6.9c-1.4-1.3-2.7-2.6-4-4c-0.3-0.3-0.6-0.7-1-1.2l-0.5-0.7L226,153c-0.5-0.8-1-1.6-1.5-2.4 c-3.6-6.1-6.9-12.5-9.7-19.1c-2.8-6.4-5.4-12.9-7.8-19.6L217.4,108z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M220.3,108.4c3,5.8,5.5,11.7,7.7,17.8l-12.7,7.1c0,0-13.4-19.6-11.1-26.2C206.7,99.8,215.9,99.9,220.3,108.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M220.3,108.4c3,5.8,5.5,11.7,7.7,17.8l-12.7,7.1c0,0-13.4-19.6-11.1-26.2C206.7,99.8,215.9,99.9,220.3,108.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M215.2,133.2l5.1-2.8c-0.3-2.6-3.2-11.7-6.7-17.2s-6.7-6.7-9.6-5.3C202.9,115.2,215.2,133.2,215.2,133.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M201.4,99.9c-5.7-0.3-11.3-0.3-16.9,0c-4.4,0.3-8.8,0.9-13.2,1.7c6.9,28.7,4.1,58.4,4.6,64.5h39.6 c6.8-41.7-2.7-64.1-2.7-64.1C209.1,101,205.2,100.3,201.4,99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M201.4,99.9c-5.7-0.3-11.3-0.3-16.9,0c-4.4,0.3-8.8,0.9-13.2,1.7c6.9,28.7,4.1,58.4,4.6,64.5h39.6 c6.8-41.7-2.7-64.1-2.7-64.1C209.1,101,205.2,100.3,201.4,99.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "173,332 178.9,337.3 167.7,348.9 161.8,343.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "182.9,337.5 190.3,337.5 189.3,354.6 181.9,354.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "173,332 167.2,338 173.1,343.3 178.8,337.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "182.4,346.3 189.8,346.3 190.3,337.5 182.9,337.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M189.4,166.1c0,0,9.4,53.3,12.2,78.8c2.9,26.3-34.4,89.4-34.4,89.4l9.9,9.3c0,0,51-70.4,48.9-94 c-2.7-29.4-10.5-83.5-10.5-83.5L189.4,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M189.4,166.1c0,0,9.4,53.3,12.2,78.8c2.9,26.3-34.4,89.4-34.4,89.4l9.9,9.3c0,0,51-70.4,48.9-94 c-2.7-29.4-10.5-83.5-10.5-83.5L189.4,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M175.6,319.3l1.5,24.3c0,0,11.2-15.4,22.9-34.3c11.2-63.7,3.3-110.9-0.3-123.4c0,0-4.1,5.7-5.5,8.5 c2.8,16.9,6,37.4,7.4,50.5C203.6,263,186.3,298.9,175.6,319.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M175.8,166.1c0,0,2.3,55,3.2,80c0.8,23,0.4,98.1,0.4,98.1H193c0,0,6.6-77,7.9-100.2 c1.2-21.3,0.5-77.9,0.5-77.9H175.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M175.8,166.1c0,0,2.3,55,3.2,80c0.8,23,0.4,98.1,0.4,98.1H193c0,0,6.6-77,7.9-100.2 c1.2-21.3,0.5-77.9,0.5-77.9H175.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M191.1,354.2c2.1,1.6,9.4,3.4,15.3,4.6c1.3,0.3,1.4,3.4-1.7,3.4S192,362,189.8,362c-3.7,0-5.1,0.2-8,0.2l0,0 c-0.7,0-1.3-0.6-1.3-1.3l0.4-6.6c0-0.3,0.2-0.5,0.5-0.5h8.3C190.2,353.8,190.6,353.9,191.1,354.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M170.7,348.4c2.9,5.4-0.3,7,11.4,10.7c1.3,0.4-0.6,3.1-3.8,3.1c-7,0-8.6-0.5-11.6-3.9 c-2.6-2.9-5.9-5.6-10.5-9.1c-0.1,0-0.2-0.1-0.2-0.1c-0.5-0.4-0.5-1.1-0.1-1.6l5.5-5.5c0.2-0.2,0.6-0.2,0.8,0l7.1,4.8 C169.8,347.2,170.3,347.7,170.7,348.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M256.2,178.3c0.7,2.4,8.8,1.7,8.8,1.7l1.6-6.1l-7.7-0.3L256.2,178.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "266.6,173.9 265,179.9 269.5,180.6 275,177.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M171.9,104.4L171.9,104.4c2.3,11.1,3.6,22.2,3.9,33.4c4-13.1,5.1-24.4,4.3-29.1 C179.3,104.2,174.5,104.1,171.9,104.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M196.2,89.8c-0.9,4.2-0.9,8.7,5.2,10.1c0,0,5.9,4.5-5.2,4.5c-10.1,0-11.7-4.5-11.7-4.5c3.7-3.6,2.2-13.6,1-19 L196.2,89.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "193.5,107.8 195.6,110.8 198,110.7 199.4,107.6 196.4,104.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M189.8,87.4c0.3,2.4,3.6,5,5.9,5.3c0-1,0.2-2,0.4-3l-6.3-5.2C189.7,85.5,189.6,86.5,189.8,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M201,76.5c4.4-2.7,1.4-12.7-2.4-14C191.5,60.1,196.6,79.2,201,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M182.8,70.2c1-5.3,6.1-8.7,11.4-7.7c7.7,1.3,11.4,11.7,11.5,18.4c0.1,1.9-0.4,3.9-1.5,5.5 c-2.9,4.5-8.8,5.8-13.3,2.9c-4.6-2.9-5.5-7.1-7.8-14.1C182.6,73.6,182.5,71.9,182.8,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M204.5,59.3c3-1-2.1-4-2.1-4c13.9,4.3,7.6,10.2-2.9,9.9c-10.5-0.3-15.2,3-13,5.9c3.7,5.1,3.7,12.3,0.8,13.2 s-10.5-9.2-11.4-13.4c-1.4-6.5,3.9-1.9,1.6-7.4C173,52.6,200.1,61,204.5,59.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M175.8,61.1c1.3,4.4,3.8,5,3.7,5C176.3,67.6,175.9,61.1,175.8,61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M194.2,58.8l6.1,2.4c2.7-0.6,5.4-2.8-1.1-4.8C199.2,56.4,203.5,60,194.2,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M182.5,78.7c2.2-1,4.9,1.1,6.1,2.9c1.3,2,0.8,4.3-1.7,4.3c-1.9-0.1-3.7-0.8-5-2.1 C180.2,82.2,180.3,79.7,182.5,78.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M194.9,73.7c0.4-0.1,0.8,0.3,1,0.9s0,1.1-0.4,1.2s-0.9-0.3-1-0.9S194.5,73.8,194.9,73.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M201.5,72.2c0.4-0.1,0.8,0.3,1,0.9s0,1.1-0.4,1.2s-0.9-0.3-1-0.9S201.1,72.3,201.5,72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M200.4,79.7c1.1,0.1,2-0.3,2.7-1.1c-1.5-1.3-2.9-2.8-4-4.4L200.4,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M194.7,80.6c-0.1,0-0.1-0.1,0-0.2c0-0.1,0.1-0.1,0.2,0c1.1,1,2.7,1.3,4.2,1c0.1,0,0.2,0,0.2,0.1 s0,0.2-0.1,0.2c-0.4,0.1-0.8,0.1-1.2,0.1C196.8,81.8,195.6,81.3,194.7,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M191.8,73.2L191.8,73.2c-0.2-0.1-0.3-0.3-0.2-0.5c0.4-1,1.3-1.8,2.4-2c0.2,0,0.4,0.1,0.4,0.3l0,0 c0,0.2-0.1,0.4-0.3,0.4c-0.9,0.2-1.6,0.8-1.9,1.6c0,0.1-0.2,0.2-0.3,0.2S191.8,73.2,191.8,73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M203.1,70.3c-0.5-0.7-1.4-1.1-2.3-1.1l0,0c-0.2,0-0.4-0.1-0.4-0.3l0,0c0-0.2,0.1-0.4,0.3-0.4 c1.1,0,2.2,0.5,2.9,1.4c0.2,0.2,0.1,0.4,0,0.5c0,0.1-0.1,0.1-0.2,0.1C203.2,70.5,203.1,70.5,203.1,70.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M179.1,112.6l-1.8,3c-0.6,1-1.1,2-1.7,3.1c-1.2,2.1-2.3,4.2-3.3,6.4s-2,4.3-2.9,6.5c-0.8,2.1-1.6,4.3-2.2,6.5 l-0.1,0.4l-0.1,0.2c0,0.1,0.1,0.1,0,0.1s-0.1,0.1-0.1,0.2c0,0.3,0,0.6,0,0.9c0.1,1,0.3,1.9,0.6,2.8c0.7,2.1,1.5,4.2,2.5,6.3 c2.1,4.3,4.5,8.7,6.9,12.9l-4.4,3.5c-3.7-3.7-7-7.8-9.9-12.1c-1.5-2.3-2.9-4.7-4-7.2c-0.7-1.5-1.2-3-1.5-4.5 c-0.2-0.9-0.3-1.9-0.3-2.8c0-0.6,0-1.1,0.1-1.7l0.1-0.4v-0.2l0.1-0.5c1-5.3,2.7-10.5,4.9-15.4c1-2.4,2.2-4.8,3.4-7.1 c0.6-1.1,1.2-2.3,1.9-3.4s1.3-2.2,2.1-3.4L179.1,112.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M190.3,354.7c0,0-0.1,0-0.1-0.1s0-0.2,0.1-0.2c0.2-0.1,2.3-1.6,3.2-1.2c0.2,0.1,0.4,0.3,0.4,0.5 c0.1,0.3,0,0.6-0.2,0.9c-0.4,0.3-0.9,0.5-1.4,0.4C191.7,355,191,354.9,190.3,354.7z M193.2,353.5c-0.8,0.2-1.6,0.5-2.3,0.9 c1.3,0.3,2.3,0.2,2.6-0.1c0.1-0.2,0.2-0.4,0.1-0.6c0-0.1-0.1-0.2-0.2-0.2S193.3,353.5,193.2,353.5L193.2,353.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M190.4,354.8c-0.1,0-0.2-0.1-0.1-0.1c0-0.1-0.2-2.3,0.6-3c0.2-0.1,0.4-0.2,0.7-0.2c0.3,0,0.5,0.2,0.6,0.5 C192.3,352.8,191.2,354.4,190.4,354.8L190.4,354.8L190.4,354.8z M191.4,351.8c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0.7-0.6,1.5-0.5,2.3 c0.7-0.5,1.4-1.7,1.3-2.2C191.8,351.9,191.7,351.8,191.4,351.8L191.4,351.8L191.4,351.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M170.3,349.4c-0.1-0.1-0.1-0.1-0.1-0.2c0.1,0,0.1-0.1,0.2-0.1c0.4-0.1,3.9-0.3,4.6,0.5 c0.1,0.1,0.2,0.3,0.1,0.5c0,0.3-0.2,0.5-0.5,0.6c-0.1,0.1-0.3,0.1-0.5,0.1C172.8,350.6,171.5,350.2,170.3,349.4z M171.1,349.5 c1.6,0.9,2.8,1.2,3.4,1c0.1-0.1,0.3-0.2,0.3-0.4c0-0.1,0-0.1,0-0.2c-0.3-0.4-1.6-0.5-2.8-0.5L171.1,349.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M170.3,349.3c0-0.1,0-0.1,0-0.2c0.1-0.1,1.4-2.8,3.1-2c0.5,0.2,0.5,0.5,0.5,0.7c-0.2,0.8-2.4,1.6-3.4,1.6l0,0 C170.4,349.5,170.3,349.4,170.3,349.3z M170.8,349.1c1.1-0.2,2.7-0.8,2.8-1.3c0-0.1-0.1-0.2-0.3-0.3s-0.3-0.1-0.5-0.1 C171.9,347.4,171.1,348.5,170.8,349.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M171.8,164.2c-0.3,3.5,6.4,3.5,6.4,3.5l3.8-8.6l-7.3,1.3L171.8,164.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "182,159.1 178.2,167.7 184.1,170.3 187.5,163.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "168.5,328.8 181.2,340.3 177.6,344.1 166.6,333.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "168.5,328.8 181.2,340.3 177.6,344.1 166.6,333.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "178.1,339.8 194.3,339 193.5,344.2 178.9,344.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "178.1,339.8 194.3,339 193.5,344.2 178.9,344.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M181.1,115.1c-2.9,8.5-9,20.1-9,20.1l-15-8.3c0,0,7.2-24.3,14.2-25.3C178.8,100.5,184.1,106.1,181.1,115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M181.1,115.1c-2.9,8.5-9,20.1-9,20.1l-15-8.3c0,0,7.2-24.3,14.2-25.3C178.8,100.5,184.1,106.1,181.1,115.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "193.5,107.8 195.6,110.8 198,110.7 199.4,107.6 196.4,104.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M195.7,110c0.4,5-0.2,19.4,0.6,28.3s4.8,18.5,4.8,18.5s2.8-11.5,2.5-18.2c-0.2-4.9-5.9-28.5-5.9-28.5 L195.7,110z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M195.7,110c0.4,5-0.2,19.4,0.6,28.3s4.8,18.5,4.8,18.5s2.8-11.5,2.5-18.2c-0.2-4.9-5.9-28.5-5.9-28.5 L195.7,110z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M185.5,97.7c-1.1,0.8-2.9,1.9-2.9,1.9c-0.6,6.5,11.9,10.9,11.9,10.9c0.1-2.2,0.8-4.3,1.9-6.1 C185.9,101.8,185.5,97.8,185.5,97.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M185.5,97.7c-1.1,0.8-2.9,1.9-2.9,1.9c-0.6,6.5,11.9,10.9,11.9,10.9c0.1-2.2,0.8-4.3,1.9-6.1 C185.9,101.8,185.5,97.8,185.5,97.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M199.6,98.9c1.1,0.2,2.2,0.6,3.2,1c1.6,6.4-4,10.2-4,10.2c-0.4-2-1.3-4-2.4-5.7 C200.4,103.1,199.6,98.9,199.6,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M199.6,98.9c1.1,0.2,2.2,0.6,3.2,1c1.6,6.4-4,10.2-4,10.2c-0.4-2-1.3-4-2.4-5.7 C200.4,103.1,199.6,98.9,199.6,98.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01PanVerfication);
export default __webpack_public_path__ + "static/media/01_pan_verfication.acfae32473308f5bccdde4249533e12c.svg";
export { ForwardRef as ReactComponent };